var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "user" },
    [
      _c("TabelToolBar"),
      _c("ListTabel"),
      _c("addBuyerDialog", {
        attrs: { isShowAddBuyerDialog: _vm.isShowAddBuyerDialog },
        on: { closeAddBuyerDialog: _vm.closeAddBuyerDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }